import checkJwtToken from './checkJwtToken';
import initIntercom from './initIntercom';
import initSharedData from './initSharedData';
import initAffiliateId from './initAffiliateId';
import { isMobileAndTablet } from 'common/utils/utils';
import checkAffiliateId from './checkAffiliateId';
import checkAgeVerificationBypass from './checkAgeVerificationBypass'
import bootstrapOthers from './others';
import { checkAndDisableConsoleLogOnProduction } from 'common/utils/helper';

export default () => {
   initSharedData();
   initIntercom();
   initAffiliateId();
   checkAffiliateId()
   checkJwtToken();
   checkAgeVerificationBypass();
   bootstrapOthers();
   if(isMobileAndTablet()) {
      document.body.classList.add('select-none')
   }
   checkAndDisableConsoleLogOnProduction()
};
